import * as XLSX from "xlsx";
import moment from "moment";

const formatRows = (data, columnOrder) => {
  return data.map((row) => columnOrder.map((key) => row[key] ?? ""));
};

export const generateExcel = (name, tableData, questionLength, headers) => {
  const workbook = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([[]]);
  const mergeCells = () => {
    const merge = [];
    let end = null;
    for (let i = 0; i < questionLength; i++) {
      const start = i === 0 ? 3 + i + 1 : end + 1;
      end = start + 1;
      merge.push({
        s: {
          c: start,
          r: 0,
        },
        e: {
          c: end,
          r: 0,
        },
      });
    }
    return merge;
  };
  ws["!merges"] = mergeCells();
  const worksheet = XLSX.utils.sheet_add_json(ws, tableData);
  XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });

  XLSX.utils.book_append_sheet(workbook, worksheet, `${name}`);

  XLSX.writeFile(workbook, `${name}_${moment().format("MMMM Do YYYY, h:mm:ss a")}.xlsx`);
};

export const generateExcelForUserResponse = (
  name,
  tableData,
  questionLength,
  headers,
  columnOrder,
  headerCount = 5,
  title = "",
) => {
  const workbook = XLSX.utils.book_new();
  const colCount = Math.max(headers?.length || 1, 1);
  const hasTitle = Boolean(title && String(title).trim());
  const headerRowIndex = hasTitle ? 1 : 0;
  const merges = [];

  const rows = [];

  if (hasTitle) {
    const titleRow = Array(colCount).fill("");
    titleRow[0] = String(title).trim();
    rows.push(titleRow);
    merges.push({
      s: { c: 0, r: 0 },
      e: { c: colCount - 1, r: 0 },
    });
  }

  rows.push(headers || []);

  let end = null;
  for (let i = 0; i < questionLength; i++) {
    const start = i === 0 ? headerCount + i : end + 1;
    end = start + 1;
    merges.push({
      s: { c: start, r: headerRowIndex },
      e: { c: end, r: headerRowIndex },
    });
  }

  const formattedRows = formatRows(tableData || [], columnOrder || headers || []);
  rows.push(...formattedRows);

  const ws = XLSX.utils.aoa_to_sheet(rows);
  ws["!merges"] = merges;
  if (hasTitle) {
    ws["!rows"] = [{ hpt: 28 }];
  }

  XLSX.utils.book_append_sheet(workbook, ws, `${name}`);
  XLSX.writeFile(workbook, `${name}_${moment().format("MMMM Do YYYY, h:mm:ss a")}.xlsx`);
};
